import React from "react";
import { message } from "antd";
import { observer } from "mobx-react-lite";
import copy from "copy-to-clipboard";
import { select } from "@/utils/dom";
import OrderOriginalId from "@/components/OrderOriginalId";
import OrderDTO from "@/dto/order/OrderDTO";
import ShopType from "@/enum/ShopType";

interface OrderOriginalIdInfoProps {
    order: OrderDTO;

    shopType?: ShopType;
}

const OrderOriginalIdInfo: React.FC<OrderOriginalIdInfoProps> = observer(function (props) {
    const { order, shopType } = props;

    return (
        <span>
            订单编号:
            <span className={`order-info-originalId-text-${order.id}`}>
                <OrderOriginalId order={order} shopType={shopType} />
            </span>
            <a
                className="text-light small ml5"
                href="#"
                onClick={(e) => {
                    e.preventDefault();

                    const el = document.querySelector<HTMLElement>(
                        `.order-info .order-info-originalId-text-${order.id}`,
                    );

                    select(el);

                    copy(el.textContent);

                    message.success("复制成功");
                }}
            >
                复制
            </a>
        </span>
    );
});

export default OrderOriginalIdInfo;
